import { FC, PropsWithChildren } from 'react';

import Link from 'next/link';

type Props = {
	href?: string;
} & PropsWithChildren;

export const WithLink: FC<Props> = ({ children, href }) => {
	if (href) {
		return (
			<Link style={{ width: '100%' }} href={href}>
				{children}
			</Link>
		);
	}

	return <>{children}</>;
};
